import { render, staticRenderFns } from "./ProfileAlerts.vue?vue&type=template&id=dbd2454e"
import script from "./ProfileAlerts.vue?vue&type=script&lang=js"
export * from "./ProfileAlerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports